<template>
	<div class="accessControlEquipmentManagementList">
		<div class="filters">
			<el-form :inline="true">
				<el-form-item>
					<el-select v-model="gardenId" @change="getListHouse" disabled>
						<el-option key :label="$t('lang.lab_chooseGarden')" :value="zero"></el-option>
						<el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="houseId" @change="getListUnit">
						<el-option key :label="$t('lang.lab_selectHouse')" :value="zero"></el-option>
						<el-option v-for="(item,index) in houseList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="unitId">
						<el-option key :label="$t('lang.lab_selectUnit')" :value="zero"></el-option>
						<el-option v-for="(item,index) in unitList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input class="searchInput" v-model="searchMacName" :placeholder="$t('lang.lab_searchEquipment')"></el-input>
				</el-form-item>
				<el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
			</el-form>
		</div>
		<el-card>
			<el-button type="primary" slot="header" @click="add">{{$t('lang.lab_addEquipment')}}</el-button>
			<el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange"
					:height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
				<el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
				<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column prop="doorMacName" :label="$t('lang.lab_inputMacEquipment')"></el-table-column>
				<el-table-column prop="doorName" :label="$t('lang.lab_EquipmentName')"></el-table-column>
				<el-table-column prop="houseName" :label="$t('lang.lbl_elevBluetoothEquipManages_houseName')"></el-table-column>
				<el-table-column prop="unitName" :label="$t('lang.lbl_elevBluetoothEquipManages_unitName')"></el-table-column>
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" width="230px">
					<template slot-scope="scope">
						<el-button @click="doorDeviceSonList(scope.row.id)">{{$t('lang.lab_DoorDeviceSon')}}</el-button>
						<!-- <el-button @click="xlDeviceList(scope.row.id)">{{$t('lang.lab_xlDevice')}}</el-button> -->
						<el-button @click="ycDeviceList(scope.row.id)">远程</el-button>
						<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
						<el-button class="orange" @click="deletetable(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
					:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper" :page-count="pageCount" />
		</el-card>
		<el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false" center top="130px" width="600px"
				@closed="handleDialogClosed">
			<el-form :model="diaForm" :rules="rules" ref="diaForm" :label-width="require('@/config/enum').c_ws8" :label-suffix="require('@/config/enum').c_colon">
				<el-form-item :label="$t('lang.diaFormgarden')" prop="gardensssss">
					<el-select v-model="diaForm.garden" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')" class="select"
							disabled>
						<el-option key="0" :label="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')" value=''></el-option>
						<el-option v-for="item in gardenDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('lang.diaFormhouse')">
					<el-select v-model="diaForm.house" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')" class="select"
						@change="getUnit">
						<el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')" :value='zero'></el-option>
						<el-option v-for="item in houseDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('lang.diaFormunit')">
					<el-select v-model="diaForm.unit" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormunit')" class="select">
						<el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormunit')" :value='zero'></el-option>
						<el-option v-for="item in unitDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_EquipmentName')" prop="doorName">
					<el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_EquipmentName')" v-model="diaForm.doorName"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_inputMacEquipment')" prop="doorMacName">
					<el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_inputMacEquipment')" v-model="diaForm.doorMacName"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_EquipmentType')" prop="type">
					<el-select v-model="diaForm.type" class="select">
						<el-option v-for="item in eqType" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用途" prop="dtype">
					<el-select v-model="diaForm.dtype" class="select">
						<el-option v-for="item in dType" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
				<el-button type="primary" @click="save('diaForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	/**
	 *@ClassName:accessControlEquipmentManagementList
	 *@Description:门禁设备管理
	 *@author:刘彦辰
	 *@Copyright:格众科技
	 *@date:2020-03-30
	 */
	export default {
		name: '/manage/main.doorDeviceList',
		data() {
			var chooseGardenId = (rule, value, callback) => {
				if (this.diaForm.garden === '') {
					callback(new Error(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.diaFormgardenId')))
				} else {
					callback()
				}
			}
			return {
				zero: 0, // 值为0的变量
				multipleSelection: [], // 多选框
				pageCount: 0, // 总页数
				title: '', // 弹框显示的标题
				pageNo: 1, // 第几页
				pageSize: 10, // 每页显示数
				types: [], // 小区下拉
				houseId: 0, // 楼号ID
				unitId: 0, // 单元号ID
				houseList: [], // 楼号列表
				unitList: [], // 单元号列表
				tableData: [], // 列表数组
				searchMacName: '', // 搜索的关键字
				disabled: true,
				editId: '', // 编辑按钮保存的id
				isPopupPage: false, // 弹框的显示控制
				gardenDialist: [], // 弹框的小区列表
				houseDialist: [], // 弹框的楼号列表
				unitDialist: [], // 弹框的单元列表
				eqType: this.$i18n.t('lang.accessControlEquipmentManagementList.TYPE'), // 下拉列表
				dType: this.$i18n.t('lang.accessControlEquipmentManagementList.DTYPE'), // 下拉列表
				diaForm: {
					garden: '',
					house: 0,
					unit: 0,
					doorName: '',
					doorMacName: '',
					type: 1,
					dtype: 1
				},
				rules: {
					doorName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_EquipmentName'),
						trigger: 'blur'
					}],
					doorMacName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_inputMacEquipment'),
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_EquipmentType'),
						trigger: 'blur'
					}],
					dtype: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Select'),
						trigger: 'blur'
					}],
					gardensssss: [{
						required: true,
						validator: chooseGardenId,
						trigger: 'change'
					}],
				},
				postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
				isDisabled: true, // 保存的可点击
				gardenId: this.$store.getters.gardenId, // 小区绑定的id
			}
		},
		created() {
			this.getGarden()
			this.getTablelist()
			this.getListHouse(this.gardenId)
		},
		watch: {
			diaForm: {
				handler(newVal, oldVal) {
					// form数据变化时 会调用此方法
					let tempRule = JSON.stringify(newVal)
					if (tempRule == this.saveData) {
						// 没变
						this.isDisabled = true
					} else {
						// 变了
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			// 弹框点击取消按钮
			clear(diaForm) {
				this.$refs[diaForm].resetFields()
				this.diaForm.garden = this.$store.getters.gardenId
				this.diaForm.house = 0
				this.diaForm.unit = 0
				this.diaForm.doorName = ''
				this.diaForm.doorMacName = ''
				this.houseDialist = []
				this.unitDialist = []
				this.diaForm.type = 1
				this.diaForm.dtype = 1
				setTimeout(() => {
					this.$refs[diaForm].clearValidate()
				}, 0)
				this.getHouse()
			},
			// 所属楼号下拉列表获取
			getHouse() {
				this.diaForm.house = 0
				this.houseDialist = []
				this.diaForm.unit = 0
				this.unitDialist = []
				this.type = 1
				this.dtype = 1
				this.$get(`/gardenGrids?type=${this.type}&parentId=${this.$store.getters.gardenId}&pageNo=1&pageSize=999`).then(res => {
						if (res && res.errCode === 0) {
							console.log(res)
							this.houseDialist = res.list
							if (this.$store.getters.gardenId === '') {
								this.diaForm.house = 0
								this.houseDialist = []
								this.diaForm.unit = 0
								this.unitDialist = []
							}
						}
					},
					error => {
						this.$message.error(error)
					})
			},
			// 所属单元下拉列表获取
			getUnit() {
				this.diaForm.unit = 0
				this.unitDialist = []
				this.type = 2
				this.dtype = 1
				this.$get(`/gardenGrids?type=${this.type}&parentId=${this.diaForm.house}&pageNo=1&pageSize=999`).then(res => {
						if (res && res.errCode === 0) {
							this.unitDialist = res.list
							if (this.diaForm.house === 0) {
								this.diaForm.unit = 0
								this.unitDialist = []
							}
						}
					},
					error => {
						this.$message.error(error)
					})
			},
			// 所属小区下拉列表获取
			getGarden() {
				this.$get(`/gardens`).then(res => {
						if (res && res.errCode === 0) {
							this.types = res.list
							this.gardenDialist = res.list
						}
					},
					error => {
						this.$message.error(error)
					})
			},
			// 添加门禁设备
			add() {
				this.diaForm.garden = this.$store.getters.gardenId
				this.diaForm.house = 0
				this.diaForm.unit = 0
				this.houseDialist = []
				this.unitDialist = []
				this.editId = ''
				this.diaForm.doorName = ''
				this.diaForm.doorMacName = ''
				this.diaForm.type = 1
				this.diaForm.dtype = 1
				this.title = this.$i18n.t('lang.lab_addEquipment')
				this.isDisabled = false
				this.isPopupPage = true
				this.getHouse()
			},
			// 跳转子门禁
			doorDeviceSonList(id) {
				this.$router.push({
					path: '/manage/doorDeviceSon',
					query: {
						id: id
					}
				})
			},
			// 跳转星朗设备
			xlDeviceList(id) {
				this.$router.push({
					path: '/manage/xlDevice',
					query: {
						id: id
					}
				})
			},
			ycDeviceList(id) {
				this.$router.push({
					path: '/manage/ycDevice',
					query: {
						id: id
					}
				})
			},
			// 编辑门禁设备
			edit(row) {
				this.title = this.$i18n.t('lang.lab_editEquipment')
				this.editId = row.id
				this.diaForm.type = row.type
				this.diaForm.dtype = row.doorType
				this.diaForm.garden = row.gardenId
				// this.diaForm.type = 1
				this.$get(`/gardenGrids?type=${this.diaForm.type}&parentId=${this.diaForm.garden}&pageNo=1&pageSize=999`).then(res => {
						if (res && res.errCode === 0) {
							this.houseDialist = res.list
						}
					},
					error => {
						this.$message.error(error)
					})
				this.diaForm.house = row.house
				if (this.diaForm.house != null && this.diaForm.house != 0) {
					this.diaForm.type = 2
					this.$get(`/gardenGrids?type=${this.diaForm.type}&parentId=${this.diaForm.house}&pageNo=1&pageSize=999`).then(res => {
							if (res && res.errCode === 0) {
								this.unitDialist = res.list
								}
							},
							error => {
								this.$message.error(error)
							})
					} else {
					this.diaForm.house = 0
					this.diaForm.unit = 0
					this.unitDialist = []
				}
				if (row.unit === null) {
					this.diaForm.unit = 0
				} else {
					this.diaForm.unit = row.unit
				}
				this.diaForm.doorMacName = row.doorMacName
				this.diaForm.doorName = row.doorName
				this.saveData = JSON.stringify(this.diaForm)
				this.isPopupPage = true
			},
			// 添加/保存按下确定
			save(diaForm) {
				if (this.editId === '') {
					this.$refs[diaForm].validate((valid) => {
						if (valid) {
							let params = {
								garden: this.diaForm.garden,
								house: this.diaForm.house,
								unit: this.diaForm.unit,
								doorName: this.diaForm.doorName,
								doorMacName: this.diaForm.doorMacName,
								type: this.diaForm.type,
								doorType: this.diaForm.dtype
							}
							let loading = this.$loading()
							this.$post(`/doorDevice`, params).then(
								res => {
									loading.close()
									// if (res && res.errCode === 0) {
									this.$message.success(this.$i18n.t('lang.lab_save_success'))
									this.isPopupPage = false
									this.commit()
									// }
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				} else {
					this.$refs[diaForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {
								garden: this.diaForm.garden,
								house: this.diaForm.house,
								unit: this.diaForm.unit,
								doorName: this.diaForm.doorName,
								doorMacName: this.diaForm.doorMacName,
								type: this.diaForm.type,
								doorType: this.diaForm.dtype
							}
							this.$patch(`/doorDevice/${this.editId}`, params).then(res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.isPopupPage = false
										this.commit()
									}
								},
								error => {
									loading.close()
									this.$message.error(error)
									this.isPopupPage = false
								})
						} else {
							return false
						}
					})
				}
			},
			// 翻页
			handleCurrentChange(val) {
				this.pageNo = val
				this.getTablelist()
			},
			// 切换每页显示多少数据
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.getTablelist()
			},
			// 监听关闭dialog
			handleDialogClosed() {
				this.$refs.diaForm.resetFields()
				this.diaForm.unit = 0
				this.diaForm.house = 0
				this.diaForm.garden = ''
				this.diaForm.type = 1
				this.diaForm.dtype = 1
				this.diaForm.name = ''
				this.diaForm.macName = ''
			},
			// 列表隔行变色
			tableRowClassName({
				row,
				rowIndex
			}) {
				return rowIndex % 2 === 0 ? 'row-dark' : ''
			},
			// ID序号功能
			indexMethod(index) {
				return (this.pageNo - 1) * this.pageSize + index + 1
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			// 门禁设备管理
			getTablelist() {
				let loading = this.$loading()
				let house = ''
				if (this.houseId === 0) {
					house = ''		
				} else {
					house = this.houseId
				}
				let unit = ''
				if (this.unitId === 0) {
					unit = ''		
				} else {
					unit = this.unitId
				}
				this.$get(
					`/doorDevice/?garden=${this.gardenId}&house=` + house + `&unit=` + unit + `&doorName=${this.searchMacName}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
				).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.tableData = res.list
							this.pageCount = res.pageCount
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			commit() {
				this.pageNo = 1
				this.getTablelist()
			},
			// 获取小区下的楼号
			getListHouse() {
				this.houseId = 0
				this.houseList = []
				this.unitId = 0
				this.unitList = []
				this.type = 1
				this.dtype = 1
				let loading = this.$loading()
				this.$get(`/gardenGrids?type=${this.type}&parentId=${this.gardenId}&pageNo=1&pageSize=999`).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.houseList = res.list
							if (this.gardenId === 0) {
								this.houseId = 0
								this.houseList = []
								this.unitId = 0
								this.unitList = []
							}
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			// 获取楼号下的单元号
			getListUnit() {
				this.unitId = 0
				this.unitList = []
				this.type = 2
				let loading = this.$loading()
				this.$get(`/gardenGrids?type=${this.type}&parentId=${this.houseId}&pageNo=1&pageSize=999`).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.unitList = res.list
							if (this.houseId === 0) {
								this.unitId = 0
								this.unitList = []
							}
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			deletetable(id) {
				let loading = this.$loading()
				this.$confirm(
						this.$i18n.t('lang.lab_isdelete'),
						this.$i18n.t('lang.lab_prompt'), {
							confirmButtonText: this.$i18n.t('lang.btn_confirm'),
							cancelButtonText: this.$i18n.t('lang.btn_cancel'),
							type: 'warning'
						}
					).then(() => {
						// 添加del的url
						this.$delete(`/doorDevice/` + id).then(res => {
								loading.close()
								if (res && res.errCode === 0) {
									this.$message({
										type: 'success',
										message: this.$i18n.t('lang.lab_del_success')
									})
									this.commit()
								}
							},
							error => {
								loading.close()
								this.$message.error(error)
							})
					})
					.catch(() => {
						loading.close()
						this.$message({
							type: 'info',
							message: this.$i18n.t('lang.lab_del_can')
						})
					})
			}
		}
	}
</script>

<style lang="scss">

</style>
